import React from "react";

import ConversationList from "./ConversationList";

const History = (props) => {
  return <ConversationList {...props} />;
};

export default History;
